import { render } from "./ClientLog.vue?vue&type=template&id=829139a4&scoped=true"
import script from "./ClientLog.vue?vue&type=script&lang=js"
export * from "./ClientLog.vue?vue&type=script&lang=js"

import "./ClientLog.vue?vue&type=style&index=0&id=829139a4&scoped=true&lang=css"

import exportComponent from "/home/runner/work/vertex/vertex/webui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-829139a4"]])

export default __exports__